import PropTypes from 'prop-types';

export const popUpDefaultProps = {
    confirmLabel: '',
    title: ''
};

export const popUpPropTypes = {
    visible: PropTypes.bool.isRequired,
    title: PropTypes.string,
    confirmLabel: PropTypes.string,
    onConfirm: PropTypes.func.isRequired
};
